import axios from "axios";

export const getFile = async (file: string) => {
  return axios.get("/files", {
    params: { file },
  });
};
